<span style="display: inline-block; vertical-align: middle;">{{this.username}}</span>
<button mat-icon-button (click)="signInOut()">
    <mat-icon>{{this.icon}}</mat-icon>
</button>
